import React from "react";
import "../css/PageLoader.scss";

const PageLoader = () => {
  return (
    <div className="page-loader">
      <div className="spinner" />
    </div>
  );
};

export default PageLoader;
